import React, { useEffect, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Link, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import Prompt from '../components/Prompt';
import { Comparison, Picks } from '../components/Tables';
import { request } from '../api';
import { chartFor } from '../components/chart';
import { SymbolChart } from '../../../platform/tradingview';
export default function PredictionDetail() {
  const {
      id
    } = useParams(),
    [data, setData] = useState(null),
    [error, setError] = useState('');
  useEffect(() => {
    let live = true;
    setData(null);
    setError('');
    request(`/predictions/${id}`).then(d => live && setData(d)).catch(e => live && setError(e.message));
    return () => {
      live = false;
    };
  }, [id]);
  const p = data?.predictions.find(p => p.id === id),
    b = data?.batch,
    chart = b && chartFor(b, data.prices);
  return <Layout title={p ? `${p.model_name} · ${b.horizon}` : 'Prediction detail'} error={error}>{p && <>
    <p>{b.status === 'settled' ? 'Settled' : 'Unsettled'} · Prediction: {b.prediction_time} · {b.horizon_count} trading sessions · {b.start_date} → {b.end_date} closing prices · Directional absolute return (<SymbolChart symbol="SPY" build={chart.build('SPY')} advice={chart.advice} /> context)</p>
    <Card><CardBody><p className="text-muted">{p.market_view}</p><Picks selections={p.selections} result={p.result} prices={data.prices} chart={chart} /></CardBody></Card>
    <Card><CardBody><h5 className="card-title mb-3">Models in this experiment</h5><Comparison predictions={data.predictions} /></CardBody></Card>
    {data.can_manage && b.status !== 'settled' && <p><Link to={`/extreme-movers/create?batch=${b.id}`}>Add another model before the deadline</Link> · <Link to={`/extreme-movers/batches/${b.id}/settlement`}>Settle this batch</Link></p>}
    <details><summary>Standardized prompt</summary><Prompt text={b.prompt} /></details>
    <details><summary>Original model response and normalized data</summary><pre>{p.raw_response}</pre><pre>{JSON.stringify(p.normalized_json, null, 2)}</pre></details>
    {data.settlement && <><p>Settled: {data.settlement.settled_at} · Formula: {data.settlement.calculation_version}</p><details><summary>Settlement audit</summary><pre>{data.settlement.prompt}</pre><pre>{data.settlement.raw_response}</pre><pre>{JSON.stringify(data.settlement.normalized_json, null, 2)}</pre></details></>}
    {data.publication && <p>Blogger: {data.publication.status} {data.publication.url && <a href={data.publication.url} target="_blank" rel="noreferrer">Read article</a>}{data.publication.last_error && ` — ${data.publication.last_error}`}
      {/* Said plainly when publishing cannot happen: a button here used to
          re-queue into a worker that was not running and report success. */}
      {data.publication_unavailable && <span className="text-warning ms-2">Publishing is off — {data.publication_unavailable}.</span>}
      {data.can_retry_publication && !data.publication_unavailable && <button onClick={async () => {
          try {
            await request(`/batches/${b.id}/publication/retry`, {});
            setData(await request(`/predictions/${id}`));
          } catch (e) {
            setError(e.message);
          }
        }}>Retry / update Blogger article</button>}
    </p>}
  </>}</Layout>;
}
